'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _basicTextPage = require('./basic-text-page');

var _basicTextPage2 = _interopRequireDefault(_basicTextPage);

var _reactIntl = require('react-intl');

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
	messages = require('../lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}

(0, _reactIntl.addLocaleData)(lang);

var SocialMedia = function SocialMedia() {
	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			_basicTextPage2.default,
			{
				pageTitle: 'Social media | Doctify',
				pageDescription: 'Social Media at Doctify. Rate, review and book doctors and specialists online',
				pagePath: (0, _doctifyUtils.getResourcePath)('/social-media')
			},
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'Social Media & Blogs'
				),
				_react2.default.createElement(
					'p',
					{ 'class': 'preamble' },
					'Follow us in our daily life and get tips on how to stay healthy.'
				),
				_react2.default.createElement(
					'h2',
					null,
					'Journal'
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'a',
						{ href: '/blog', target: '_blank' },
						'Doctify Journal'
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'Instagram'
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'a',
						{ href: 'https://instagram.com/doctify/', target: '_blank' },
						'instagram.com/doctify'
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'Facebook'
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'a',
						{ href: 'https://www.facebook.com/doctifyuk', target: '_blank' },
						'facebook.com/doctifyuk'
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'Google+'
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'a',
						{ href: 'https://plus.google.com/u/0/111311986530482578105/posts/', target: '_blank' },
						'Doctify on Google+'
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'Twitter'
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'a',
						{ href: 'https://twitter.com/doctifyuk', target: '_blank' },
						'twitter.com/doctifyuk'
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'Linked In'
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'a',
						{ href: 'https://www.linkedin.com/company/doctify', target: '_blank' },
						'linkedin.com/company/doctify'
					)
				)
			)
		)
	);
};

SocialMedia.displayName = 'SocialMedia';

SocialMedia.defaultProps = {};

exports.default = SocialMedia;


// WEBPACK FOOTER //
// ./components/info-page/lib/components/social-media-page.js